import { type useAdminAgentTraceRequests } from '@apps/web/swr_data_fetching/admin_agent_traces';
import { type AgentRuntime } from '@libraries/typescript/api_client';

type RequestAgentRuntime = NonNullable<
    NonNullable<
        Parameters<typeof useAdminAgentTraceRequests>[0]
    >['agent_runtime']
>;

export const REQUEST_AGENT_VIEW_KEYS = ['caregiver', 'client'] as const;
export type RequestAgentView = (typeof REQUEST_AGENT_VIEW_KEYS)[number];

export const REQUEST_AGENT_VIEWS = {
    caregiver: {
        agentRuntime: 'caregiver_sms',
        path: '/admin/agent-traces/caregiver',
        title: 'Caregiver requests',
        tabLabel: 'Caregiver',
        filterStorageKey: 'admin-agent-traces-caregiver-request-filters',
        filtersByEntityTag: true,
    },
    client: {
        agentRuntime: 'client',
        path: '/admin/agent-traces/client',
        title: 'Client requests',
        tabLabel: 'Client',
        filterStorageKey: 'admin-agent-traces-client-request-filters',
        filtersByEntityTag: false,
    },
} as const satisfies Record<
    RequestAgentView,
    {
        readonly agentRuntime: RequestAgentRuntime;
        readonly path: string;
        readonly title: string;
        readonly tabLabel: string;
        readonly filterStorageKey: string;
        readonly filtersByEntityTag: boolean;
    }
>;

export function requestAgentViewForRuntime(
    agentRuntime: AgentRuntime,
): RequestAgentView | null {
    return (
        REQUEST_AGENT_VIEW_KEYS.find(
            (view) => REQUEST_AGENT_VIEWS[view].agentRuntime === agentRuntime,
        ) ?? null
    );
}
